import { useState } from 'react';

import { TITLE_ICON_TYPE } from '~/common/componentMapper/QuestionBox/constants';
import Box from '~/common/components/Box';

import language from '../../../utils/language.json';
import { StyledLinkButton } from '../../styledComponents/styledButtons';
import { StyledSmartAnswerText } from '../../styledComponents/styledComponents';
import DetailedAnswer from '../smartAnswer/DetailedAnswer';

/**
 * @param {number} iconType - The type of icon that is being displayed.
 * @returns {boolean} - Returns true if the BOLT answer should be hidden, otherwise false.
 */

function shouldHideBOLTAnswer(iconType) {
  return iconType === TITLE_ICON_TYPE.NEW || iconType === TITLE_ICON_TYPE.USER;
}

type SmartAnswerProps = {
  detailedAnswer?: string;
  iconType?: string;
  smartAnswer?: any;
};

export default function SmartAnswer({
  smartAnswer,
}: Readonly<SmartAnswerProps>) {
  const { iconType, aiResponse } = smartAnswer;
  const isBOLTAnswerHidden = shouldHideBOLTAnswer(iconType);
  const [showBOLTAnswer, setShowBOLTAnswer] = useState(false);
  const boltAnswer = isBOLTAnswerHidden ? aiResponse?.answer : null;

  const toggleShowBOLTAnswer = () => {
    setShowBOLTAnswer((prev) => !prev);
  };

  return (
    <>
      {isBOLTAnswerHidden && (
        <StyledLinkButton
          variant="link"
          color={'blue.600'}
          onClick={toggleShowBOLTAnswer}
          data-tracking="show-footer-confidence-bolt-answer"
          paddingTop={'1rem'}
          paddingBottom={
            !isBOLTAnswerHidden || showBOLTAnswer ? '0rem' : '1rem'
          }
        >
          {showBOLTAnswer
            ? language.HIDE_BOLT_ANSWER
            : language.SHOW_BOLT_ANSWER}
        </StyledLinkButton>
      )}
      {(!isBOLTAnswerHidden || showBOLTAnswer) && (
        <Box>
          {boltAnswer && (
            <StyledSmartAnswerText>
              {language.BOLT_ANSWER} {boltAnswer}
            </StyledSmartAnswerText>
          )}
          <DetailedAnswer
            paddingTop={boltAnswer ? '0' : '1rem'}
            detailedAnswer={aiResponse?.detailedAnswer ?? ''}
            isOpen={isBOLTAnswerHidden}
          />
        </Box>
      )}
    </>
  );
}
